/**
 * SenderIdManagementService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateSenderIDRequestRouteDto } from '../model/createSenderIDRequestRouteDto';
import { CreateSenderIdRequestBulkUploadDto } from '../model/createSenderIdRequestBulkUploadDto';
import { RequestForm } from '../model/requestForm';
import { SenderIdRequestProcessingModel } from '../model/senderIdRequestProcessingModel';
import { SenderIdRequestProcessingModelGenericResponse } from '../model/senderIdRequestProcessingModelGenericResponse';
import { SenderIdRequestProcessingModelPaginatedResponse } from '../model/senderIdRequestProcessingModelPaginatedResponse';
import { SenderIdRequestStatus } from '../model/senderIdRequestStatus';
import { SenderIdRouteResponseDto } from '../model/senderIdRouteResponseDto';
import { SenderIdStatusResponseDto } from '../model/senderIdStatusResponseDto';
import { SenderIdType } from '../model/senderIdType';
import { SenderRequestRouteModelGenericResponse } from '../model/senderRequestRouteModelGenericResponse';
import { StringGenericResponse } from '../model/stringGenericResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SenderIdRequestService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestCreateSenderIdRequestBulkUploadPost(body?: Array<CreateSenderIdRequestBulkUploadDto>, observe?: 'body', reportProgress?: boolean): Observable<SenderIdRequestProcessingModelGenericResponse>;
    public apiSenderIdRequestCreateSenderIdRequestBulkUploadPost(body?: Array<CreateSenderIdRequestBulkUploadDto>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderIdRequestProcessingModelGenericResponse>>;
    public apiSenderIdRequestCreateSenderIdRequestBulkUploadPost(body?: Array<CreateSenderIdRequestBulkUploadDto>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderIdRequestProcessingModelGenericResponse>>;
    public apiSenderIdRequestCreateSenderIdRequestBulkUploadPost(body?: Array<CreateSenderIdRequestBulkUploadDto>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SenderIdRequestProcessingModelGenericResponse>('post',`${this.basePath}/api/SenderIdRequest/CreateSenderIdRequestBulkUpload`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param authorizationLetter 
     * @param request 
     * @param serviceProviderId 
     * @param requestId 
     * @param requestType 
     * @param serviceOwner 
     * @param aggregatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestCreateSenderIdRequestPostForm(authorizationLetter?: Blob, request?: RequestForm, serviceProviderId?: string, requestId?: string, requestType?: SenderIdType, serviceOwner?: string, aggregatorId?: string, observe?: 'body', reportProgress?: boolean): Observable<SenderIdRequestProcessingModelGenericResponse>;
    public apiSenderIdRequestCreateSenderIdRequestPostForm(authorizationLetter?: Blob, request?: RequestForm, serviceProviderId?: string, requestId?: string, requestType?: SenderIdType, serviceOwner?: string, aggregatorId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderIdRequestProcessingModelGenericResponse>>;
    public apiSenderIdRequestCreateSenderIdRequestPostForm(authorizationLetter?: Blob, request?: RequestForm, serviceProviderId?: string, requestId?: string, requestType?: SenderIdType, serviceOwner?: string, aggregatorId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderIdRequestProcessingModelGenericResponse>>;
    public apiSenderIdRequestCreateSenderIdRequestPostForm(authorizationLetter?: Blob, request?: RequestForm, serviceProviderId?: string, requestId?: string, requestType?: SenderIdType, serviceOwner?: string, aggregatorId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (authorizationLetter !== undefined) {
            formParams = formParams.append('AuthorizationLetter', <any>authorizationLetter) as any || formParams;
        }
        if (request !== undefined) {
            formParams = formParams.append('Request', <any>request) as any || formParams;
        }
        if (serviceProviderId !== undefined) {
            formParams = formParams.append('ServiceProviderId', <any>serviceProviderId) as any || formParams;
        }
        if (requestId !== undefined) {
            formParams = formParams.append('RequestId', <any>requestId) as any || formParams;
        }
        if (requestType !== undefined) {
            formParams = formParams.append('RequestType', <any>requestType) as any || formParams;
        }
        if (serviceOwner !== undefined) {
            formParams = formParams.append('ServiceOwner', <any>serviceOwner) as any || formParams;
        }
        if (aggregatorId !== undefined) {
            formParams = formParams.append('AggregatorId', <any>aggregatorId) as any || formParams;
        }

        return this.httpClient.request<SenderIdRequestProcessingModelGenericResponse>('post',`${this.basePath}/api/SenderIdRequest/CreateSenderIdRequest`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestDeleteSenderIdRequestDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<SenderRequestRouteModelGenericResponse>;
    public apiSenderIdRequestDeleteSenderIdRequestDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderRequestRouteModelGenericResponse>>;
    public apiSenderIdRequestDeleteSenderIdRequestDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderRequestRouteModelGenericResponse>>;
    public apiSenderIdRequestDeleteSenderIdRequestDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SenderRequestRouteModelGenericResponse>('delete',`${this.basePath}/api/SenderIdRequest/DeleteSenderIdRequest`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param status 
     * @param senderIdName 
     * @param serviceProviderId 
     * @param processingPartnerId 
     * @param ncc 
     * @param telco 
     * @param regulator 
     * @param aggregatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestGetAllRequestByStatusGet(status?: SenderIdRequestStatus, senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SenderIdRequestProcessingModel>>;
    public apiSenderIdRequestGetAllRequestByStatusGet(status?: SenderIdRequestStatus, senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdRequestGetAllRequestByStatusGet(status?: SenderIdRequestStatus, senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdRequestGetAllRequestByStatusGet(status?: SenderIdRequestStatus, senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (senderIdName !== undefined && senderIdName !== null) {
            queryParameters = queryParameters.set('senderIdName', <any>senderIdName);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (processingPartnerId !== undefined && processingPartnerId !== null) {
            queryParameters = queryParameters.set('ProcessingPartnerId', <any>processingPartnerId);
        }
        if (ncc !== undefined && ncc !== null) {
            queryParameters = queryParameters.set('Ncc', <any>ncc);
        }
        if (telco !== undefined && telco !== null) {
            queryParameters = queryParameters.set('telco', <any>telco);
        }
        if (regulator !== undefined && regulator !== null) {
            queryParameters = queryParameters.set('Regulator', <any>regulator);
        }
        if (aggregatorId !== undefined && aggregatorId !== null) {
            queryParameters = queryParameters.set('aggregatorId', <any>aggregatorId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SenderIdRequestProcessingModel>>('get',`${this.basePath}/api/SenderIdRequest/GetAllRequestByStatus`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param senderIdName 
     * @param serviceProviderId 
     * @param processingPartnerId 
     * @param ncc 
     * @param telco 
     * @param regulator 
     * @param aggregatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestGetAllSenderIdRequestGet(senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SenderIdRequestProcessingModel>>;
    public apiSenderIdRequestGetAllSenderIdRequestGet(senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdRequestGetAllSenderIdRequestGet(senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdRequestGetAllSenderIdRequestGet(senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (senderIdName !== undefined && senderIdName !== null) {
            queryParameters = queryParameters.set('senderIdName', <any>senderIdName);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (processingPartnerId !== undefined && processingPartnerId !== null) {
            queryParameters = queryParameters.set('ProcessingPartnerId', <any>processingPartnerId);
        }
        if (ncc !== undefined && ncc !== null) {
            queryParameters = queryParameters.set('Ncc', <any>ncc);
        }
        if (telco !== undefined && telco !== null) {
            queryParameters = queryParameters.set('telco', <any>telco);
        }
        if (regulator !== undefined && regulator !== null) {
            queryParameters = queryParameters.set('Regulator', <any>regulator);
        }
        if (aggregatorId !== undefined && aggregatorId !== null) {
            queryParameters = queryParameters.set('aggregatorId', <any>aggregatorId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SenderIdRequestProcessingModel>>('get',`${this.basePath}/api/SenderIdRequest/GetAllSenderIdRequest`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param status 
     * @param senderIdName 
     * @param serviceProviderId 
     * @param processingPartnerId 
     * @param ncc 
     * @param telco 
     * @param regulator 
     * @param aggregatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestGetAllShortCodeGet(status?: SenderIdRequestStatus, senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SenderIdRequestProcessingModel>>;
    public apiSenderIdRequestGetAllShortCodeGet(status?: SenderIdRequestStatus, senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdRequestGetAllShortCodeGet(status?: SenderIdRequestStatus, senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdRequestGetAllShortCodeGet(status?: SenderIdRequestStatus, senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (senderIdName !== undefined && senderIdName !== null) {
            queryParameters = queryParameters.set('senderIdName', <any>senderIdName);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (processingPartnerId !== undefined && processingPartnerId !== null) {
            queryParameters = queryParameters.set('ProcessingPartnerId', <any>processingPartnerId);
        }
        if (ncc !== undefined && ncc !== null) {
            queryParameters = queryParameters.set('Ncc', <any>ncc);
        }
        if (telco !== undefined && telco !== null) {
            queryParameters = queryParameters.set('telco', <any>telco);
        }
        if (regulator !== undefined && regulator !== null) {
            queryParameters = queryParameters.set('Regulator', <any>regulator);
        }
        if (aggregatorId !== undefined && aggregatorId !== null) {
            queryParameters = queryParameters.set('aggregatorId', <any>aggregatorId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SenderIdRequestProcessingModel>>('get',`${this.basePath}/api/SenderIdRequest/GetAllShortCode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param senderIdName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestGetSenderIdRouteSenderIdNameGet(senderIdName: string, observe?: 'body', reportProgress?: boolean): Observable<SenderIdRouteResponseDto>;
    public apiSenderIdRequestGetSenderIdRouteSenderIdNameGet(senderIdName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderIdRouteResponseDto>>;
    public apiSenderIdRequestGetSenderIdRouteSenderIdNameGet(senderIdName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderIdRouteResponseDto>>;
    public apiSenderIdRequestGetSenderIdRouteSenderIdNameGet(senderIdName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (senderIdName === null || senderIdName === undefined) {
            throw new Error('Required parameter senderIdName was null or undefined when calling apiSenderIdRequestGetSenderIdRouteSenderIdNameGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SenderIdRouteResponseDto>('get',`${this.basePath}/api/SenderIdRequest/GetSenderIdRoute/${encodeURIComponent(String(senderIdName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param senderIdName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestGetSenderIdSenderIdNameGet(senderIdName: string, observe?: 'body', reportProgress?: boolean): Observable<SenderIdRequestProcessingModel>;
    public apiSenderIdRequestGetSenderIdSenderIdNameGet(senderIdName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderIdRequestProcessingModel>>;
    public apiSenderIdRequestGetSenderIdSenderIdNameGet(senderIdName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderIdRequestProcessingModel>>;
    public apiSenderIdRequestGetSenderIdSenderIdNameGet(senderIdName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (senderIdName === null || senderIdName === undefined) {
            throw new Error('Required parameter senderIdName was null or undefined when calling apiSenderIdRequestGetSenderIdSenderIdNameGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SenderIdRequestProcessingModel>('get',`${this.basePath}/api/SenderIdRequest/GetSenderId/${encodeURIComponent(String(senderIdName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param senderIdName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestGetSenderIdStatusSenderIdNameGet(senderIdName: string, observe?: 'body', reportProgress?: boolean): Observable<SenderIdStatusResponseDto>;
    public apiSenderIdRequestGetSenderIdStatusSenderIdNameGet(senderIdName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderIdStatusResponseDto>>;
    public apiSenderIdRequestGetSenderIdStatusSenderIdNameGet(senderIdName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderIdStatusResponseDto>>;
    public apiSenderIdRequestGetSenderIdStatusSenderIdNameGet(senderIdName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (senderIdName === null || senderIdName === undefined) {
            throw new Error('Required parameter senderIdName was null or undefined when calling apiSenderIdRequestGetSenderIdStatusSenderIdNameGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SenderIdStatusResponseDto>('get',`${this.basePath}/api/SenderIdRequest/GetSenderIdStatus/${encodeURIComponent(String(senderIdName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param senderIdName 
     * @param serviceProviderId 
     * @param processingPartnerId 
     * @param ncc 
     * @param telco 
     * @param regulator 
     * @param aggregatorId 
     * @param page 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestGetallsenderidGet(senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, page?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<SenderIdRequestProcessingModelPaginatedResponse>;
    public apiSenderIdRequestGetallsenderidGet(senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, page?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderIdRequestProcessingModelPaginatedResponse>>;
    public apiSenderIdRequestGetallsenderidGet(senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, page?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderIdRequestProcessingModelPaginatedResponse>>;
    public apiSenderIdRequestGetallsenderidGet(senderIdName?: string, serviceProviderId?: string, processingPartnerId?: string, ncc?: string, telco?: string, regulator?: string, aggregatorId?: string, page?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (senderIdName !== undefined && senderIdName !== null) {
            queryParameters = queryParameters.set('senderIdName', <any>senderIdName);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (processingPartnerId !== undefined && processingPartnerId !== null) {
            queryParameters = queryParameters.set('ProcessingPartnerId', <any>processingPartnerId);
        }
        if (ncc !== undefined && ncc !== null) {
            queryParameters = queryParameters.set('Ncc', <any>ncc);
        }
        if (telco !== undefined && telco !== null) {
            queryParameters = queryParameters.set('telco', <any>telco);
        }
        if (regulator !== undefined && regulator !== null) {
            queryParameters = queryParameters.set('Regulator', <any>regulator);
        }
        if (aggregatorId !== undefined && aggregatorId !== null) {
            queryParameters = queryParameters.set('aggregatorId', <any>aggregatorId);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('pageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SenderIdRequestProcessingModelPaginatedResponse>('get',`${this.basePath}/api/SenderIdRequest/getallsenderid`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestMapSenderIdRequestToRoutePost(body?: Array<CreateSenderIDRequestRouteDto>, observe?: 'body', reportProgress?: boolean): Observable<SenderRequestRouteModelGenericResponse>;
    public apiSenderIdRequestMapSenderIdRequestToRoutePost(body?: Array<CreateSenderIDRequestRouteDto>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderRequestRouteModelGenericResponse>>;
    public apiSenderIdRequestMapSenderIdRequestToRoutePost(body?: Array<CreateSenderIDRequestRouteDto>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderRequestRouteModelGenericResponse>>;
    public apiSenderIdRequestMapSenderIdRequestToRoutePost(body?: Array<CreateSenderIDRequestRouteDto>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SenderRequestRouteModelGenericResponse>('post',`${this.basePath}/api/SenderIdRequest/MapSenderIdRequestToRoute`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestUnmapSenderIdRouteIdGet(id: string, observe?: 'body', reportProgress?: boolean): Observable<SenderIdRouteResponseDto>;
    public apiSenderIdRequestUnmapSenderIdRouteIdGet(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderIdRouteResponseDto>>;
    public apiSenderIdRequestUnmapSenderIdRouteIdGet(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderIdRouteResponseDto>>;
    public apiSenderIdRequestUnmapSenderIdRouteIdGet(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSenderIdRequestUnmapSenderIdRouteIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SenderIdRouteResponseDto>('get',`${this.basePath}/api/SenderIdRequest/UnmapSenderIdRoute/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdRequestUploadLetterPostForm(file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<StringGenericResponse>;
    public apiSenderIdRequestUploadLetterPostForm(file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StringGenericResponse>>;
    public apiSenderIdRequestUploadLetterPostForm(file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StringGenericResponse>>;
    public apiSenderIdRequestUploadLetterPostForm(file?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<StringGenericResponse>('post',`${this.basePath}/api/SenderIdRequest/UploadLetter`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
